import React, { Component }  from 'react'
import {Link} from "@mui/material";
import "./CopyRightLinkRaikoStyleSheet.css"
import {useRef} from "react";
import Tooltip from '@mui/material/Tooltip';

const CopyRightLinkRaiko = () => {
    const positionRef = useRef({
        x: 0,
        y: 0,
    });

    const popperRef = useRef(null);
    const areaRef = useRef(null);

    const handleMouseMove = (event) => {
        positionRef.current = {x: event.clientX, y: event.clientY};

        if (popperRef.current != null) {
            popperRef.current.update();
        }
    };

    return (
        <Tooltip
            title="بیا یه سر به ما بزن !"
            placement="top"
            arrow
            PopperProps={{
                popperRef,
                anchorEl: {
                    getBoundingClientRect: () => {
                        return new DOMRect(
                            positionRef.current.x,
                            areaRef.current.getBoundingClientRect().y,
                            0,
                            0,
                        );
                    },
                },
            }}
        >
            <Link
                href="https://raiko.app"
                target='_blank'
                className="copyRightLink"
                ref={areaRef}
                onMouseMove={handleMouseMove}
            >
                <span>©</span>
                <span>طراحی و توسعه ی وب با</span>
                <span id="copyRightHeart">🧡</span>
                <span>توسط رایکو</span>
            </Link>
        </Tooltip>
    )
}

export default CopyRightLinkRaiko;